import { atom, useAtomValue, useSetAtom } from 'jotai'
import { atomWithGlobalStore } from '@highlight/ipc/jotai'

const transcriptHeightAtom = atom(0)

export const useTranscriptHeight = () => useAtomValue(transcriptHeightAtom)
export const useSetTranscriptHeight = () => useSetAtom(transcriptHeightAtom)

export const transcriptViewAtom = atom<'labeled' | 'raw'>('labeled')

export const useTranscriptView = () => useAtomValue(transcriptViewAtom)
export const useSetTranscriptView = () => useSetAtom(transcriptViewAtom)

const copyLinkStatusAtom = atom<'idle' | 'loading' | 'copied' | 'finished' | 'closed'>('idle')

export const useCopyLinkStatus = () => useAtomValue(copyLinkStatusAtom)
export const useSetCopyLinkStatus = () => useSetAtom(copyLinkStatusAtom)

/** Settings-store key behind the Developers > Sidepanel toggle that adds the day's schedule to the meeting popover. */
export const MEETING_POPOVER_SCHEDULE_SHOWN_KEY = 'sidepanel.meetingPopoverScheduleShown'

// Every meeting row mounts a popover that reads this, so it hydrates before any popover can open.
const meetingPopoverScheduleShownAtom = atomWithGlobalStore<boolean>(
  'settings',
  MEETING_POPOVER_SCHEDULE_SHOWN_KEY,
  false,
)

export const useMeetingPopoverScheduleShown = () => useAtomValue(meetingPopoverScheduleShownAtom)
